import useErrors from '../../../../hooks/useErrors';
import server from '../../../../services/server';
import { processAndSaveContractText } from '../../../../utils/processAndSaveContractText';
import DocumentInputMasked from '../../../../components/DocumentInputMasked';
import { isNumericCnpj, unmaskDocument } from '../../../../utils/documentMask';
import PhoneInputMasked from '../../../../components/PhoneInputMasked';
import Address from '../../../../components/Address';
import { SearchRounded } from '@mui/icons-material';
import {
    Alert,
    Button,
    Divider,
    IconButton,
    InputAdornment,
    MenuItem,
    Select,
    Stack,
    TextField,
} from '@mui/material';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useEffect, useState } from 'react';

const schemaTermo = Yup.object().shape({
    document: Yup.string().required('Documento é obrigatório'),
    companyName: Yup.string().required('Razão Social é obrigatório'),
    tradeName: Yup.string().required('Nome Fantasia é obrigatório'),
    stateRegistration: Yup.string().required('Inscrição Estadual é obrigatório'),
    zipcode: Yup.string().required('CEP é obrigatório'),
    address: Yup.string().required('Endereço é obrigatório'),
    number: Yup.string().required('Número é obrigatório'),
    complement: Yup.string().required('Complemento é obrigatório'),
    neighborhood: Yup.string().required('Bairro é obrigatório'),
    city: Yup.string().required('Cidade é obrigatório'),
    state: Yup.string().required('Estado é obrigatório'),

    contractorName: Yup.string().required('Nome do Contratante é obrigatório'),
    contractorDocument: Yup.string().required('Documento do Contratante é obrigatório'),
    contractorNationality: Yup.string().required('Nacionalidade do Contratante é obrigatório'),
    contractorPhone: Yup.string().required('Telefone do Contratante é obrigatório'),
    // contractorBirthDate: Yup.string().required('Data de Nascimento do Contratante é obrigatório'),
    // contractorGender: Yup.string().required('Gênero do Contratante é obrigatório'),
    contractorPosition: Yup.string().required('Cargo do Contratante é obrigatório'),
    contractorEmail: Yup.string().email('O email deve ser válido').required('Email do Contratante é obrigatório'),
    ///email: Yup.string().required('Email é obrigatório'),
    //position: Yup.string().required('Cargo é obrigatório'),
    //phone: Yup.string().required('Telefone é obrigatório'),
    //mobile: Yup.string().required('Celular é obrigatório'),
    // value: Yup.string().required('Mensalidade é obrigatório'),
    // planId: Yup.string().required('Plano é obrigatório'),
    // paymentMethod: Yup.string().required('Forma de Pagamento é obrigatório'),
    // paymentDay: Yup.string().required('Dia de Pagamento é obrigatório'),
});

export function Termo({ mutate, contract }) {
    const { setErrors, enqueueSnackbar } = useErrors();
    const { values, getFieldProps, setFieldValue, setValues, isSubmitting, errors, handleSubmit, handleBlur, isValid, touched } = useFormik({
        initialValues: {
            document: '',
            companyName: '',
            tradeName: '',
            stateRegistration: '',
            // isExempt: false,
            // isSimpleOptant: false,
            address: '',
            number: '',
            complement: '',
            neighborhood: '',
            city: '',
            state: '',
            zipcode: '',
            contractorName: '',
            contractorDocument: '',
            contractorNationality: '',
            contractorPhone: '',
            // contractorBirthDate: '',
            // contractorGender: '',
            contractorPosition: '',
            contractorEmail: '',
            // domain: '',

            // paymentMethod: '',
            // paymentDay: '',
        },
        // validationSchema: schemaTermo,
        // validateOnChange: true,
        // validateOnMount: true,
        // validateOnBlur: true,
        //enableReinitialize: true,
        onSubmit: async (values, { setSubmitting }) => {
            try {
                setSubmitting(true);
                delete values.contractData;
                await server.put(`subscription/${contract.uuid}/term`, values);
                await mutate?.();
                await processAndSaveContractText(contract.uuid, { mutate });
                setSubmitting(false);
                enqueueSnackbar('Termo de adesão armazenado.');
            } catch (error) {
                console.log(error);
                setSubmitting(false);
                setErrors(error);
            }
        },
    });

    //WESLEY
    useEffect(() => {
        if (Boolean(contract)) {
            const source = contract?.contractData?.contract || contract?.contractData || {};
            setValues({ ...values, ...source }, true);
            if (Boolean(contract?.clubId)) {
                setValues({
                    companyName: contract?.Club?.businessName,
                    tradeName: contract?.Club?.name,
                    document: contract?.Club?.document,
                    zipcode: contract?.Club?.zipcode,
                    complement: contract?.Club?.complement,
                    number: contract?.Club?.number,
                    street: contract?.Club?.street,
                    neighborhood: contract?.Club?.neighborhood,
                    city: contract?.Club?.city,
                    state: contract?.Club?.state,
                    country: contract?.Club?.country,
                    email: contract?.Club?.email,
                    phone: contract?.Club?.phone,
                    phone2: contract?.Club?.phone2,
                    phone3: contract?.Club?.phone3,
                });
            }
            if (contract?.contractData?.contract) {
                setFieldValue('contractorName', contract?.contractData?.contract?.contractorName);
                setFieldValue('contractorDocument', contract?.contractData?.contract?.contractorDocument);
                setFieldValue('contractorNationality', contract?.contractData?.contract?.contractorNationality);
                setFieldValue('contractorPosition', contract?.contractData?.contract?.contractorPosition);
                setFieldValue('contractorEmail', contract?.contractData?.contract?.contractorEmail);
                setFieldValue('contractorPhone', contract?.contractData?.contract?.contractorPhone);
            }
        }
    }, [contract]);

    const [hasCompany, setHasCompany] = useState(false);



    const hasContract = Boolean(contract?.integrationId);
    const hasTerm = Boolean(contract);
    const hasSignature = Boolean(contract.signedAt);
    const concludedTermAt = Boolean(contract.concludedTermAt);

    async function onBlurGetDocument(document) {
        //consulta o cnpj na https://open.cnpja.com/office/ e preenche os dados da empresa
        try {
            const normalizedDocument = unmaskDocument(document);
            if (!isNumericCnpj(normalizedDocument)) return;
            const response = await fetch(`https://open.cnpja.com/office/${normalizedDocument}`);
            const data = await response.json();

            setHasCompany(data);

            // corpo da resposta
            // {
            //     "updated": "2025-10-11T00:00:00.000Z",
            //     "taxId": "01715377000190",
            //     "alias": "Eurobem Multi Clube de Beneficios",
            //     "founded": "1997-02-28",
            //     "head": true,
            //     "company": {
            //         "members": [
            //             {
            //                 "since": "1997-02-28",
            //                 "person": {
            //                     "id": "9827a6de-bd49-4770-90b8-0fe2691b7970",
            //                     "type": "NATURAL",
            //                     "name": "Lucimar Elias Teixeira Donas",
            //                     "taxId": "***719361**",
            //                     "age": "61-70"
            //                 },
            //                 "role": {
            //                     "id": 49,
            //                     "text": "Sócio-Administrador"
            //                 }
            //             },
            //             {
            //                 "since": "2008-10-22",
            //                 "person": {
            //                     "id": "a532c640-185b-4a36-807c-9299270048cf",
            //                     "type": "NATURAL",
            //                     "name": "Miguel Nuno Correia Donas",
            //                     "taxId": "***687541**",
            //                     "age": "61-70"
            //                 },
            //                 "role": {
            //                     "id": 49,
            //                     "text": "Sócio-Administrador"
            //                 }
            //             },
            //             {
            //                 "since": "2022-03-21",
            //                 "person": {
            //                     "id": "c54cd951-b50e-4a7b-9389-82ccdcc6dd82",
            //                     "type": "NATURAL",
            //                     "name": "Aliny Cristina Teixeira Mendonca",
            //                     "taxId": "***999391**",
            //                     "age": "31-40"
            //                 },
            //                 "role": {
            //                     "id": 49,
            //                     "text": "Sócio-Administrador"
            //                 }
            //             }
            //         ],
            //         "id": 1715377,
            //         "name": "EUROBEM ADMINISTRACAO E SERVICOS LTDA",
            //         "equity": 100000,
            //         "nature": {
            //             "id": 2062,
            //             "text": "Sociedade Empresária Limitada"
            //         },
            //         "size": {
            //             "id": 1,
            //             "acronym": "ME",
            //             "text": "Microempresa"
            //         },
            //         "simples": {
            //             "optant": true,
            //             "since": "2024-01-01"
            //         },
            //         "simei": {
            //             "optant": false,
            //             "since": null
            //         }
            //     },
            //     "statusDate": "2005-11-03",
            //     "status": {
            //         "id": 2,
            //         "text": "Ativa"
            //     },
            //     "address": {
            //         "municipality": 5208707,
            //         "street": "Avenida 136",
            //         "number": "960",
            //         "district": "Set Marista",
            //         "city": "Goiânia",
            //         "state": "GO",
            //         "details": "Quadraf47 Lote 19/23 Sala 1302",
            //         "zip": "74180040",
            //         "country": {
            //             "id": 76,
            //             "name": "Brasil"
            //         }
            //     },
            //     "mainActivity": {
            //         "id": 6399200,
            //         "text": "Outras atividades de prestação de serviços de informação não especificadas anteriormente"
            //     },
            //     "phones": [
            //         {
            //             "type": "LANDLINE",
            //             "area": "62",
            //             "number": "39422604"
            //         }
            //     ],
            //     "emails": [
            //         {
            //             "ownership": "CORPORATE",
            //             "address": "financeiro@eurobem.com.br",
            //             "domain": "eurobem.com.br"
            //         }
            //     ],
            //     "sideActivities": [
            //         {
            //             "id": 6391700,
            //             "text": "Agências de notícias"
            //         },
            //         {
            //             "id": 6622300,
            //             "text": "Corretores e agentes de seguros, de planos de previdência complementar e de saúde"
            //         },
            //         {
            //             "id": 8299799,
            //             "text": "Outras atividades de serviços prestados principalmente às empresas não especificadas anteriormente"
            //         }
            //     ],
            //     "suframa": []
            // }

            setFieldValue('companyName', data.company.name);
            setFieldValue('tradeName', data.alias);
            // setFieldValue('stateRegistration', data.stateRegistration);
            setFieldValue('zipcode', data.address.zip);
            setFieldValue('street', data.address.street);
            setFieldValue('address', `${data.address.street}, ${data.address.district}, ${data.address.city}-${data.address.state}`);
            setFieldValue('number', data.address.number);
            setFieldValue('complement', data.address.details);
            setFieldValue('neighborhood', data.address.district);
            setFieldValue('city', data.address.city);
            setFieldValue('state', data.address.state);


        } catch (error) {
            enqueueSnackbar('Erro ao consultar o CNPJ. Preencha manualmente.', { variant: 'error' });
        }
    }



    return (
        <Stack spacing={2}>
            <>
                <Divider>Dados jurídicos</Divider>
                <TextField
                    label="CNPJ"
                    {...getFieldProps('document')}
                    onBlur={handleBlur}
                    fullWidth
                    InputProps={{
                        inputComponent: DocumentInputMasked,
                        inputProps: { documentType: 'cnpj' },
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton onClick={() => onBlurGetDocument(values.document)}>
                                    <SearchRounded />
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                    error={touched?.document && !!errors.document}
                    helperText={touched?.document && errors.document}
                />
                <TextField
                    label="Razão Social"
                    {...getFieldProps('companyName')}
                    onBlur={handleBlur}
                    fullWidth
                    error={touched?.companyName && !!errors.companyName}
                    helperText={touched?.companyName && errors.companyName}
                />
                <TextField
                    label="Nome Fantasia"
                    {...getFieldProps('tradeName')}
                    onBlur={handleBlur}
                    fullWidth
                    error={touched?.tradeName && !!errors.tradeName}
                    helperText={touched?.tradeName && errors.tradeName}
                />
                {/* <TextField
                    label="Inscrição Estadual"
                    {...getFieldProps('stateRegistration')}
                    onBlur={handleBlur}
                    fullWidth
                    error={touched?.stateRegistration && !!errors.stateRegistration}
                    helperText={touched?.stateRegistration && errors.stateRegistration}
                /> */}
                <Address
                    {...getFieldProps('zipcode')}
                    setFieldValue={setFieldValue}
                    address={values?.address}
                    onBlur={handleBlur}
                    error={touched.address && !!errors.zipcode}
                    helperText={touched?.zipcode && errors.zipcode}
                />
                <Stack direction="row" columnGap={2}>
                    <TextField
                        fullWidth
                        label="Complemento"
                        {...getFieldProps('complement')}
                        onBlur={handleBlur}
                        error={touched?.complement && !!errors.complement}
                        helperText={touched?.complement && errors.complement}
                    />
                    <TextField
                        sx={{ width: 150 }}
                        label="Número"
                        {...getFieldProps('number')}
                        onBlur={handleBlur}
                        error={touched?.number && !!errors.number}
                        helperText={touched?.number && errors.number}
                    />
                </Stack>

                <Divider>Dados do responsável contratante</Divider>
                {hasCompany && (
                    <>
                        {/* select com os socios da company em hasCompaby */}
                        <Select
                            label="Sócio"
                            onChange={e => {
                                //setar todos os dados do socio no formik
                                setFieldValue(
                                    'contractorName',
                                    hasCompany.company.members.find(member => member.person.id === e.target.value).person.name,
                                );
                                // setFieldValue('contractorDocument', hasCompany.company.members.find(member => member.person.id === e.target.value).person.taxId);
                                setFieldValue(
                                    'contractorNationality',
                                    hasCompany.company.members.find(member => member.person.id === e.target.value).person.nationality,
                                );
                                setFieldValue(
                                    'contractorPosition',
                                    hasCompany.company.members.find(member => member.person.id === e.target.value).role.text,
                                );
                                //setFieldValue('contractorEmail', hasCompany.company.members.find(member => member.person.id === e.target.value).person.email);
                                //setFieldValue('contractorPhone', hasCompany.company.members.find(member => member.person.id === e.target.value).person.phone);
                            }}
                            fullWidth
                            error={touched?.contractorName && !!errors.contractorName}
                            helperText={touched?.contractorName && errors.contractorName}
                        >
                            {hasCompany?.company?.members.map(member => (
                                <MenuItem key={member.person.id} value={member.person.id}>
                                    {member.person.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </>
                )}

                <TextField
                    label="Nome do Contratante"
                    {...getFieldProps('contractorName')}
                    fullWidth
                    error={touched?.contractorName && !!errors.contractorName}
                    helperText={touched?.contractorName && errors.contractorName}
                    onBlur={handleBlur}
                />
                <TextField
                    label="CPF do contratante"
                    {...getFieldProps('contractorDocument')}
                    fullWidth
                    InputProps={{
                        inputComponent: DocumentInputMasked,
                        inputProps: { documentType: 'cpf' },
                    }}
                    error={touched?.contractorDocument && !!errors.contractorDocument}
                    helperText={touched?.contractorDocument && errors.contractorDocument}
                    onBlur={handleBlur}
                />
                <TextField
                    label="Email"
                    {...getFieldProps('contractorEmail')}
                    fullWidth
                    error={touched?.contractorEmail && !!errors.contractorEmail}
                    helperText={touched?.contractorEmail && errors.contractorEmail}
                    onBlur={handleBlur}
                />
                <TextField
                    label="Nacionalidade"
                    {...getFieldProps('contractorNationality')}
                    fullWidth
                    error={touched?.contractorNationality && !!errors.contractorNationality}
                    helperText={touched?.contractorNationality && errors.contractorNationality}
                    onBlur={handleBlur}
                />
                <TextField
                    label="Cargo"
                    {...getFieldProps('contractorPosition')}
                    fullWidth
                    error={touched?.contractorPosition && !!errors.contractorPosition}
                    helperText={touched?.contractorPosition && errors.contractorPosition}
                    onBlur={handleBlur}
                />
                <TextField
                    label="Telefone"
                    {...getFieldProps('contractorPhone')}
                    fullWidth
                    error={touched?.contractorPhone && !!errors.contractorPhone}
                    helperText={touched?.contractorPhone && errors.contractorPhone}
                    InputProps={{
                        onBlur: handleBlur,
                        inputComponent: PhoneInputMasked,
                    }}
                />
                 

                <Divider />
                <Button
                    variant="contained"
                    sx={{ alignSelf: 'flex-end' }}
                    // disabled={!isValid || isSubmitting || hasSignature || !hasContract}
                    disabled={isSubmitting}
                    onClick={handleSubmit}
                >
                    Salvar dados
                </Button>
            </>

            {hasContract && (
                <>
                    <Divider />
                    <Alert severity="success">Contrato gerado com sucesso</Alert>
                </>
            )}
        </Stack>
    );
}
